<div class="mc-header">
  <nav class="ssp-navbar navbar navbar-default navbar-fixed-top">
    <div class="container-fluid no-margin">
      <div class="navbar-left">
        <img class="mc-logo" src="assets/images/logo.png" />
        <div class="navbar-text">
          <span>{{ 'label_SSP' | xsI18n }}</span>
        </div>
      </div>

      <div class="navbar-right">
        <div class="language-selector-container">
          <select class="form-control language-selector" (change)="translateLanguageTo($event)">
            <option
              *ngFor="let language of supportedLanguage"
              [value]="language.code"
              [selected]="language.code === translate.currentLang"
            >
              {{ language.caption | xsI18n }}
            </option>
          </select>
        </div>
        <div class="logout" (click)="onLogout()">
          <label class="hd-icon hd-icon-logout icon-lg"></label>
          <span>{{ 'label_Logout' | xsI18n }}</span>
        </div>
      </div>
    </div>
  </nav>
</div>
